/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { PdfSection } from './pdf-section';
import { NameValue } from '../../tool/name-value';
import jsPDF from 'jspdf';
import { PdfUtils } from '../pdf-utils';
import { PdfHeader } from '../pdf-header';
import { TranslateService } from '@ngx-translate/core';

export class SimplePdfSection extends PdfSection {
  private value: NameValue;
  constructor(title: string, value: NameValue) {
    super(title);
    this.value = value;
  }
  public getDimension(doc): { w: number; h: number } {
    return doc.getTextDimensions(this.value.name);
  }
  public build(
    trl: TranslateService,
    doc: jsPDF,
    header: PdfHeader,
    x: number,
    y: number
  ): number {
    const maxHeight = doc.internal.pageSize.getHeight() - 30;
    doc.setDrawColor(47, 55, 58);
    doc.setTextColor(47, 55, 58);
    doc.setFontSize(10);
    const text = `${this.value.value}`.split('\n');
    const dimension = doc.getTextDimensions(this.value.name);
    doc.setFont('roboto', 'bold');
    doc.text(this.value.name, x + this.margin.w, y + this.margin.h);
    doc.setFont('roboto', 'normal');
    doc.text(
      ': ' + text[0],
      x + this.margin.w + dimension.w + 4,
      y + this.margin.h
    );
    const x2 = doc.internal.pageSize.getWidth() - 30 - x;
    let newY = y + this.margin.h;

    for (let i = 1; i < text.length; ++i) {
      const t = text[i];
      newY = newY + PdfUtils.getMinHeight(doc, t, x2 - 30);
      if (newY > maxHeight) {
        doc.rect(x, y, x2, newY - y + 10); // Rect logo
        PdfUtils.addPage(doc, header);
        y = header.height;
        newY = y + this.margin.h;
      }
      doc.text(t, x + this.margin.w, newY);
    }
    doc.rect(x, y, x2, newY - y + 10); // Rect logo
    return newY;
  }
}
